import { useFlag } from '@calendly/feature-check-react'
import { Loader } from '@calendly/ui/components/loader'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { RemoteContactsSearchHandler } from 'features/crm'
import { useRightRail } from 'features/right_rail'

import { AvatarDropdown } from './avatar_dropdown'
import { FullStoryExclude } from '../../../../../../shared/fullstory_privacy'

export const CrmInvitee = ({
  isCancelled,
  isRescheduled,
  isConfirmed,
  isGuest,
  openEditEmailModal,
  isGroup,
  turnOnNoShowClicked,
  canEditEmail,
  canMarkNoShow,
  event,
  invitee,
  toggle,
  canReschedule,
  canCancel,
  canBlock,
  canUnblock,
  isOpen,
  sendAnalytics,
}) => {
  const [contact, setContact] = useState()
  const [displayName, setDisplayName] = useState()
  const shouldShowMenu = Boolean(canReschedule || canCancel || canEditEmail || canBlock || canUnblock)
  const history = useHistory()

  const handleResults = (results) => {
    const result = results?.[0]
    setContact(result)
    setDisplayName(result?.name || invitee.name || invitee.email)
  }

  const { openOrReplace, close } = useRightRail()
  const isCRMContactCardFlagEnabled = useFlag('crm_contactcard_feature')
  const isCRMContactDetailFlagEnabled = useFlag('crm_contactdetails_feature')
  const isCRMContactDetailsPageEnabled = isCRMContactCardFlagEnabled && isCRMContactDetailFlagEnabled
  const useCrmHeaderClick = () => {
    if (isGuest) return
    if (sendAnalytics && !isCRMContactDetailsPageEnabled) sendAnalytics()
    if (contact) {
      if (isCRMContactDetailsPageEnabled) {
        close()
        // open contacts page
        history.push(`/app/contacts/${contact.id}`)
        if (sendAnalytics) sendAnalytics('contact_details_view', contact.id)
      } else {
        // open right rail
        openOrReplace('remote_contacts', { contactId: contact.id })
      }
    } else {
      toggle()
    }
  }

  return (
    <FullStoryExclude>
      <RemoteContactsSearchHandler
        query={invitee.email}
        onResults={handleResults}
      />
      {!displayName && <Loader data-testid="contact-loader" size="small" />}
      {displayName && (
        <AvatarDropdown
          displayName={displayName}
          contact={contact}
          isCancelled={isCancelled}
          isRescheduled={isRescheduled}
          isConfirmed={isConfirmed}
          isGuest={isGuest}
          onHeadingClick={useCrmHeaderClick}
          openEditEmailModal={openEditEmailModal}
          isGroup={isGroup}
          turnOnNoShowClicked={turnOnNoShowClicked}
          canEditEmail={canEditEmail}
          canMarkNoShow={canMarkNoShow}
          canReschedule={canReschedule}
          canCancel={canCancel}
          canBlock={canBlock}
          canUnblock={canUnblock}
          event={event}
          invitee={invitee}
          toggle={toggle}
          isOpen={isOpen}
          shouldShowMenu={shouldShowMenu}
        />
      )}
    </FullStoryExclude>
  )
}
